import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=5b4b48c6&scoped=true&"
import script from "./ConfirmButton.vue?vue&type=script&lang=js&"
export * from "./ConfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b48c6",
  null
  
)

export default component.exports